module.exports = __webpack_public_path__ + "static/img/hwaq_xxyjxt_bg_systemimg.a4500ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hwaq_xxyjxt_bg_systemimg.png
// module id = tJs4
// module chunks = 21